import { createTheme as createMuiTheme } from '@mildang/mui';
import createPalette from './createCustomPalette';
import createTypography from './createTypography';
import createComponents from './createComponents';
import shadows, { dividerDark, dividerLight } from './shadows';
import { breakpoints } from './breakpoints';
import { zIndex } from './zIndex';

interface createThemeProps {
  isMildangPTOnly?: boolean;
}

const createMilTheme = (props: createThemeProps) => {
  const { isMildangPTOnly = false } = props ?? {};
  const palette = createPalette();
  const typography = createTypography({ palette, isMildangPTOnly });

  const defaultTheme = createMuiTheme({
    palette,
    typography,
    shadows,
    opacity: {
      disabled: 0.38,
    },
  });

  const components = createComponents(defaultTheme);

  return createMuiTheme({
    components: components,
    palette,
    typography,
    shadows,
    breakpoints,
    mixins: {
      toolbar: {
        minHeight: 56,
      },
    },
    dividerDark,
    dividerLight,

    opacity: {
      disabled: 0.38,
    },
    zIndex,
  });
};

export default createMilTheme;
// Extra Small
